import { ConvexError } from "convex/values";

export const inputClass =
  "rounded-lg border border-[#d1d1cf] bg-[#fdfdfc] px-3 py-2 text-base sm:text-sm text-[#222] placeholder:text-neutral-400 outline-none transition-colors focus:border-[#222] dark:border-[#2a2a28] dark:bg-[#141413] dark:text-[#ededeb] dark:placeholder:text-neutral-500 dark:focus:border-[#ededeb]";

export const selectClass =
  "rounded-lg border border-[#d1d1cf] bg-[#fdfdfc] px-3 py-2 text-base sm:text-sm text-[#222] outline-none transition-colors focus:border-[#222] dark:border-[#2a2a28] dark:bg-[#141413] dark:text-[#ededeb] dark:focus:border-[#ededeb] cursor-pointer";

export const primaryButtonClass =
  "cursor-pointer rounded-xl bg-[#222] px-4 py-2 text-xs font-semibold tracking-wide text-[#fdfdfc] shadow-xs transition-all hover:bg-[#111] hover:shadow-sm active:scale-[0.99] disabled:opacity-40 disabled:cursor-not-allowed dark:bg-[#ededeb] dark:text-[#141413] dark:hover:bg-white";

export const secondaryButtonClass =
  "cursor-pointer rounded-xl border border-[#d1d1cf] bg-[#fdfdfc] px-3.5 py-1.5 text-xs font-medium tracking-tight text-[#222] transition-all hover:bg-[#fafaf8] hover:border-neutral-400 active:scale-[0.99] disabled:opacity-40 disabled:cursor-not-allowed dark:border-[#2a2a28] dark:bg-[#141413] dark:text-[#ededeb] dark:hover:bg-[#1a1a19] dark:hover:border-neutral-600";

export const cardClass =
  "relative rounded-xl border border-[#d1d1cf] bg-[#fdfdfc] p-5 dark:border-[#2a2a28] dark:bg-[#141413] transition-colors";

export const monoMetaClass =
  "font-mono text-xs text-neutral-500 dark:text-neutral-400 tracking-tight";

export const badgeClass =
  "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 font-mono text-[10px] tracking-tight";

/**
 * Convex mutations reject with a ConvexError carrying the message we threw.
 * Anything else is a bug or a transport failure and gets the fallback.
 */
export function errorMessage(caught: unknown, fallback: string): string {
  if (caught instanceof ConvexError && typeof caught.data === "string") {
    return caught.data;
  }
  return fallback;
}

export function formatElapsed(ms: number): string {
  const total = Math.floor(ms / 1000);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  return hours > 0
    ? `${hours}:${pad(minutes)}:${pad(seconds)}`
    : `${pad(minutes)}:${pad(seconds)}`;
}

